export default "__VITE_ASSET__vLI89_nD__"